import React, { ReactNode } from 'react';
import { transformHTMLParserLinks } from '../../../../../../utils/rewriteLink/rewriteLink';
import { addressValidationSemaphore } from '../../../../util/addressValidationSemaphore';
import useFormDirections from '../../FormDirections/useFormDirections';
import { usePageProperties } from '../../../../providers/PagePropertiesProvider';
import useSessionStorageCheck from '../../../../../../hooks/useSessionStorageCheck';
import { useSessionStorageStatus } from '../../../../../../providers/SessionStorageStatus/SessionStorageStatusProvider';
import { Row, Col } from '../../../../../../importCL';

export default function Form({ children }: { children: ReactNode }) {
    const { formTitle, formSubtitle, version } = usePageProperties();
    const { onSubmitHandler } = useFormDirections();
    const { status } = useSessionStorageStatus();
    useSessionStorageCheck();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (status === 'usable') {
            await addressValidationSemaphore.acquire();
            onSubmitHandler();
            addressValidationSemaphore.release();
        }
    };
    return (
        <form className='mb-6'
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
                if (e.key === "Enter" && !(e.target instanceof HTMLButtonElement)) {
                    e.preventDefault();
                }
            }}
            noValidate
        >
            {(formTitle || formSubtitle) &&
                <Row>
                    <Col>
                        {formTitle &&
                            <p className='font-bold'>{transformHTMLParserLinks(formTitle)}</p>
                        }
                        {formSubtitle &&  version !== 'versionA' && (
                            <p>{transformHTMLParserLinks(formSubtitle.replace(/\*/g, '<span class="PqdeForm-Form__asterisk">*</span>'))}</p>
                        )}
                    </Col>
                </Row>
            }
            {children}
        </form>
    );


}